import { fuseListConstants } from "../_redux-constants";
import { fuseListService } from "../../_services";

function getFuseList(queryParams) {
  function getFuseListLoad() {
    return { type: fuseListConstants.FUSE_LIST_LOADING };
  }
  function FuseListSuccess(data) {
    return { type: fuseListConstants.FUSE_LIST_SUCCESS, data };
  }
  function FuseListFailure(error) {
    return { type: fuseListConstants.FUSE_LIST_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(getFuseListLoad());
    fuseListService.getFuseList(queryParams).then(
      (data) => {
        dispatch(FuseListSuccess(data));
      },
      (error) => {
        dispatch(FuseListFailure(error?.toString()));
      }
    );
  };
}

export const fuseListActions = {
  getFuseList,
};
